export default __webpack_public_path__ + "static/media/misc-books5-1024w.73b8bb91.png";